/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { ImageUploadRepresentation, TenantEvent, TenantRepresentation } from '../model';
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class AdminTenantsApi extends BaseApi {
    createTenant(createTenantRepresentation) {
        throwIfNotDefined(createTenantRepresentation, 'groupId');
        return this.post({
            path: '/api/enterprise/admin/tenants',
            bodyParam: createTenantRepresentation
        });
    }
    deleteTenant(tenantId) {
        throwIfNotDefined(tenantId, 'tenantId');
        const pathParams = {
            tenantId
        };
        return this.delete({
            path: '/api/enterprise/admin/tenants/{tenantId}',
            pathParams
        });
    }
    getTenantEvents(tenantId) {
        throwIfNotDefined(tenantId, 'tenantId');
        const pathParams = {
            tenantId
        };
        return this.get({
            path: '/api/enterprise/admin/tenants/{tenantId}/events',
            pathParams,
            returnType: TenantEvent
        });
    }
    getTenantLogo(tenantId) {
        throwIfNotDefined(tenantId, 'tenantId');
        const pathParams = {
            tenantId
        };
        return this.get({
            path: '/api/enterprise/admin/tenants/{tenantId}/logo',
            pathParams
        });
    }
    getTenant(tenantId) {
        throwIfNotDefined(tenantId, 'tenantId');
        const pathParams = {
            tenantId
        };
        return this.get({
            path: '/api/enterprise/admin/tenants/{tenantId}',
            pathParams,
            returnType: TenantRepresentation
        });
    }
    getTenants() {
        return this.get({
            path: '/api/enterprise/admin/tenants'
        });
    }
    update(tenantId, createTenantRepresentation) {
        throwIfNotDefined(tenantId, 'tenantId');
        throwIfNotDefined(createTenantRepresentation, 'createTenantRepresentation');
        const pathParams = {
            tenantId
        };
        return this.put({
            path: '/api/enterprise/admin/tenants/{tenantId}',
            pathParams,
            bodyParam: createTenantRepresentation,
            returnType: TenantRepresentation
        });
    }
    uploadTenantLogo(tenantId, file) {
        throwIfNotDefined(tenantId, 'tenantId');
        throwIfNotDefined(file, 'file');
        const pathParams = {
            tenantId
        };
        const formParams = {
            file
        };
        return this.post({
            path: '/api/enterprise/admin/tenants/{tenantId}/logo',
            pathParams,
            formParams,
            contentTypes: ['multipart/form-data'],
            returnType: ImageUploadRepresentation
        });
    }
}
